import * as typeform from '@typeform/embed';
import '@typeform/embed/build/css/popup.css';

let popup: ReturnType<typeof typeform.createPopup> | null = null;

export const showProfilingPopup = (email: string, userId: string) => {
  if (!popup) {
    popup = typeform.createPopup('UQMv202K', {
      hidden: {
        email,
        user_id: userId,
      },
      width: 400,
      height: 600,
      autoClose: 1,
    });
  }
  popup.toggle();
};
